import { AmplitudeEvent } from "@/telemetry/AmplitudeEvent";
import MeetingState from "@/constants/MeetingState";

export class MeetingDetailsOpenedEvent extends AmplitudeEvent {
	static STATE_MAP = {
		"": "unknown",
		[ MeetingState.CREATED ]: "not started",
		[ MeetingState.MEETING_STARTED ]: "started",
		[ MeetingState.MEETING_ENDED ]: "ended",
		[ MeetingState.MEETING_COMPLETED ]: "finalized",
	}
	constructor( meetingId, meetingState = "" ) {
		super();
		this.name = "Meeting Details Opened";
		this.eventProperties.meeting_id = meetingId;
		this.eventProperties.meeting_state = MeetingDetailsOpenedEvent.STATE_MAP[ meetingState ];
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/MeetingDetailsOpenedEvent.js